<template>
  <div id="divContainer" v-on:click="exitmenu" class="page-effect">
    <!-- <TopMenu /> -->
    <section
      id="sectionId"
      class="sponsors-list-wrapper d-flex body-content"
      @click="onClickHandler"
    >
      <!--@click="onClickHandler"-->

      <div class="container-fluid sponsor_litswrap">
        <!------top area start--->
        <div class="row">
          <div class="col-md-6 align-items-center d-flex position-relative">
            <h1 id="headerText" class="page-head text-uppercase my-3 my-md-0">
              <v-autocomplete
                v-if="$route.path.includes('mainlobby')"
                dense
                outlined
                v-model="sponsorEvent"
                :items="$store.state.MappedEvent"
                prepend-inner-icon="search"
                return-object
                hide-details
                label="Select Event"
                item-text="EventFullName"
              ></v-autocomplete>
              <template v-else>{{ headerText }}</template>
            </h1>
            <!-- mobile search button -->
            <div class="d-block d-md-none">
              <button
                class="mob_search_button"
                v-on:click="mob_spolist_search()"
              >
                <img
                  src="../assets/Images/icons/search-black.svg"
                  alt="e2m"
                  width="20px"
                />
              </button>
            </div>
            <!-- mobile search button end -->
          </div>
          <div class="col-md-6 new-addendee-list">
            <div class="row justify-content-end">
              <div class="col-lg-8 mb-3" v-show="IsShowSearch">
                <div class="right-search-hld" id="mob_spon_search">
                  <div class="position-relative fixed-w full-width search-hld">
                    <!--  v-if="ShowSearch" -->
                    <!--<form
                      id="newsletter-validate-detail"
                      action
                      method
                      class="form subscribe"
                    >-->
                    <!-- <input
                        id="InputSearch"
                        type="text"
                        @keyup="searchSponsors"
                        v-model="searchtext"
                        placeholder="Type & hit Enter to Search by Name, Company, Title or keywords...  "
                      /> -->
                    <input
                      id="InputSearch"
                      type="text"
                      @keyup="searchSponsors"
                      v-on:keydown.enter.prevent="searchSponsors"
                      v-model="searchtext"
                      placeholder="Search by Name, Company, Title, Keywords and click on Go"
                    />
                    <div class="reset-search-btn">
                      <p
                        v-if="searchtext"
                        @click="
                          searchtext = '';
                          searchSponsors();
                        "
                      >
                        <v-icon dark small color="#8a8a8a">mdi-close</v-icon>
                      </p>
                    </div>
                    <!--</form>-->
                  </div>
                  <a href="javascript:void(0);" @click="searchSponsors">GO</a>
                </div>
              </div>
              <!-----filter start---->
              <!-- <div class="dropdown">
                <button
                  class="ad-btn d-lg-inline-block dropdown-toggle"
                  type="button"
                  id="dropdownMenu2"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-tag="SponsorsFilter"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30px"
                    height="30px"
                    viewBox="0 0 16.5 15"
                  >
                    <path
                      id="filter.svg"
                      fill="#242432"
                      d="M181.241,159.157c0,0.013,0,.025,0,0.037a0.532,0.532,0,0,1,.006.056,0.744,0.744,0,0,1-.284.583L175.25,166.3v6.453h-0.011a0.713,0.713,0,0,1-.082.366,0.747,0.747,0,0,1-1.005.3l-3.023-1.532a0.715,0.715,0,0,1-.368-0.631H170.75V166.3l-5.716-6.463a0.747,0.747,0,0,1-.284-0.584,0.523,0.523,0,0,1,.006-0.057c0-.012,0-0.023,0-0.034a0.736,0.736,0,0,1,.066-0.23c0.008-.017.017-0.033,0.027-0.05A0.722,0.722,0,0,1,165,158.7c0.007-.007.01-0.016,0.018-0.023s0.018-.008.027-0.015a0.748,0.748,0,0,1,.208-0.113l0.057-.017a0.705,0.705,0,0,1,.191-0.028h15a0.705,0.705,0,0,1,.191.028c0.02,0,.038.011,0.058,0.018a0.722,0.722,0,0,1,.206.112c0.009,0.007.02,0.008,0.028,0.015s0.011,0.016.019,0.023a0.75,0.75,0,0,1,.145.182c0.01,0.017.02,0.034,0.029,0.052A0.76,0.76,0,0,1,181.241,159.157Zm-9.172,6.377a0.716,0.716,0,0,1,.169.466h0.012v4.791l1.5,0.76V166h0.012a0.716,0.716,0,0,1,.169-0.466L178.825,160h-11.65Z"
                      transform="translate(-164.75 -158.5)"
                    />
                  </svg>
                  <span class="cart-item" style="display:none;"></span>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                  <ul class="filter-listing clearfix remember" id="dropFilter"></ul>
                </div>
              </div>-->
              <!-----filter end---->
              <div
                class="col-md-4 mb-3 mb-md-0 pl-md-1 comm-width-fillter-new"
                v-show="isShowFilter"
              >
                <div class="position-relative fixed-w full-width filter-hld">
                  <select>
                    <option value="All">{{ $t("filter.All") }}</option>
                    <option>Group1</option>
                    <option>Group2</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!------top area end---->
        <h3 class="text-center">
          <span id="spnHeaderText"></span>
        </h3>
        <div class="sponsors-inner-hld">
          <div id="divMainiRow">
            <div class="row" id="divSponsor">
              <div
                v-for="sponsors in finalSponsorList"
                v-bind:key="sponsors.id"
                class="col-lg-3 col-md-6 filterPanel"
                v-bind:title="sponsors.Level"
              >
                <router-link
                  class
                  v-bind:to="{
                    name: 'SponsorsDetailsNew',
                    params: { sid: sponsors.id },
                  }"
                  :data-tag="'sponsor/' + sponsors.id + '/' + sponsors.Name"
                >
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        v-bind:src="
                          sponsors.Logo != '' ? sponsors.Logo : defaultLogo
                        "
                        v-bind:alt="sponsors.Name"
                      />
                    </span>
                    <div
                      class="grey-bg-texthld"
                      :data-tag="'sponsor/' + sponsors.id + '/' + sponsors.Name"
                    >
                      <h3
                        :data-tag="
                          'sponsor/' + sponsors.id + '/' + sponsors.Name
                        "
                      >
                        {{ sponsors.Name }}
                      </h3>
                      <p
                        :data-tag="
                          'sponsor/' + sponsors.id + '/' + sponsors.Name
                        "
                      >
                        {{ sponsors.Level }}
                      </p>
                      <p
                        v-if="
                          sponsors.Category != null &&
                          sponsors.Category.CategoryName != null
                        "
                        class="sponsor-category-listing"
                      >
                        <span class>{{ sponsors.Category.CategoryName }}</span>
                      </p>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import db from "../components/firebaseInit";
//import TopMenu from "@/components/TopMenu.vue";
import store from "../store";
import jQuery from "jquery";
import analytics from "@/components/Analytics";
let $ = jQuery;

let lastVisible = null;
let hasMore = true;
import axios from "axios";
var self;
export default {
  data() {
    return {
      sponsorEvent: null,
      EnableSponsorDBsearch: false,
      IsShowSearch: true,
      isShowFilter: false,
      headerText: this.$t("sponsors.sponsors"),
      clientID: this.$store.getters.getClient[0].id,
      searchtext: "",
      IsSearchMode: false,
      pageSize: 9,
      pageIndex: 0,
      totalRecords: 1,
      sponsorsData: [],
      textColor: "black",
      defaultLogo:
        "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2Fdefault_sponser_logo.png?alt=media",
    };
  },
  computed: {
    finalSponsorList() {
      let resultList = [];
      let searchText = self.searchtext.trim().toLowerCase();
      self.sponsorsData.forEach(function (item) {
        let name = item.Name ? item.Name.trim().toLowerCase() : "";
        if (searchText == "" || name.includes(searchText)) {
          resultList.push(item);
        }
      });
      return resultList;
    },
  },
  watch: {
    sponsorEvent(val) {
      if (val) {
        this.$store.commit("addEventCollection", val.iceId);
        this.$store.commit("addEventID", val.EventId);
        self.IsSearchMode = true;
        self.getDBSearchedSponsors();
      }
    },
  },
  created() {
    lastVisible = null;
    self = this;
    hasMore = true;
  },
  beforeDestroy() {
    lastVisible = null;
    self.sponsorsData = [];
    self.searchtext = "";
  },
  async mounted() {
    await this.getSponsorData();
  },
  methods: {
    async getSponsorData() {
      self.searchtext = "";
      window.addEventListener("scroll", this.scroll);
      document.body.addEventListener("scroll", this.scroll);
      lastVisible = null;
      self = this;
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      /*++++++++ Header color Brancing JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      //-------------dynamic font selection --------------------------------------
      if (obj.EventFont != undefined) {
        if (obj.EventFont.length > 0) {
          debugger;
          var urlpath = "";
          if (obj.EventFont[0].FontPath != "") {
            if (obj.EventFont[0].FontFamily != "") {
              urlpath = obj.EventFont[0].FontPath;

              var newStyle = document.createElement("style");
              newStyle.appendChild(
                document.createTextNode(
                  "\
@font-face {\
    font-family: " +
                    obj.EventFont[0].FontFamily +
                    ";\
    src:" +
                    urlpath +
                    " ;\
}\
"
                )
              );

              document.head.appendChild(newStyle);

              $(
                "<style>* { font-family: '" +
                  obj.EventFont[0].FontFamily +
                  "' !important }</style>"
              ).appendTo("head");
            }
          } else {
            $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
              "head"
            );
          }
        }
      }
      //-------------dynamic font selection --------------------------------------
      //-------Page Title-------------

      db.collection(obj.eventcollectionname)
        .doc("Menu")
        .get()
        .then((doc) => {
          var data = doc.data();
          $.each(data.LeftMenu, function (key, value) {
            if (value.GroupID != 99) {
              if (value.Name == "Sponsors") {
                if (self.$store.state.locale == "English") {
                  self.headerText = value.DisplayLabel;
                } else if (self.$store.state.locale == "German") {
                  self.headerText = value.DisplayLabel_de;
                } else if (self.$store.state.locale == "French") {
                  self.headerText = value.DisplayLabel_fr;
                } else if (self.$store.state.locale == "Chinese") {
                  self.headerText = value.DisplayLabel_zh;
                } else if (self.$store.state.locale == "Spanish") {
                  self.headerText = value.DisplayLabel_es;
                } else {
                  self.headerText = value.DisplayLabel;
                }
                document.title = self.headerText + " - " + obj.eventname;
                document.getElementById("headerText").innerText =
                  self.headerText;
              }
            }
          });
          $.each(data.AllMenu, function (key, value) {
            if (value.GroupID != 99) {
              if (value.Name == "Sponsors") {
                if (self.$store.state.locale == "English") {
                  self.headerText = value.DisplayLabel;
                } else if (self.$store.state.locale == "German") {
                  self.headerText = value.DisplayLabel_de;
                } else if (self.$store.state.locale == "French") {
                  self.headerText = value.DisplayLabel_fr;
                } else if (self.$store.state.locale == "Chinese") {
                  self.headerText = value.DisplayLabel_zh;
                } else if (self.$store.state.locale == "Spanish") {
                  self.headerText = value.DisplayLabel_es;
                } else {
                  self.headerText = value.DisplayLabel;
                }
                document.title = self.headerText + " - " + obj.eventname;
                document.getElementById("headerText").innerText =
                  self.headerText;
              }
            }
          });
        });

      debugger;

      //-------------------FAVICONJOB------------------------------------------------------------
      debugger;
      if (obj.branding[0].favicon != undefined) {
        if (obj.branding[0].favicon != "") {
          var link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = obj.branding[0].favicon;
          document.getElementsByTagName("head")[0].appendChild(link);
        }
      }
      //----------------------------------------------------------------------------------
      var brandingData;
      try {
        brandingData = await self.getBrandingJSONDetails(
          obj.eventcollectionname + "/Branding/Branding.json"
        );
        if (brandingData.data != undefined) {
          if (brandingData.data.EventInfo != undefined) {
            if (brandingData.data.EventInfo.BodyTextColor != undefined) {
              self.textColor = brandingData.data.EventInfo.BodyTextColor;
            } else {
              self.textColor = "black";
            }
          } else {
            self.textColor = "black";
          }
          console.log("BodyTextColor :- " + self.textColor);
          $("#headerText").css("color", self.textColor);
        }
      } catch (e) {
        console.log("Error in Branding Json Fetch--", e);
      }

      //------------------------------------------------------------------------------
      $("#imgBanner").attr("src", obj.EventBranding[0].banner);
      $("#topmenu").show();
      $("#leftmenu").show();
      //if ($("#ulLeftMenu li").length > 0) {
      //  $("#leftMenuParent").show();
      //  $("#leftmenu").show();
      //} else {
      //  $("#leftMenuParent").hide();
      //  $("#leftmenu").hide();
      //}
      $("#btnAddUserView").click();

      if (obj.sponsordetails === true) {
        store.commit("addSponsorDetails", false);
      }
      this.displaySponsors();
      //this.scroll();

      $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
      $("#sectionId").css(
        "background-image",
        "url(" + obj.EventBranding[0].eventBGImage + ")"
      );
    },
    onClickHandler(event) {
      // event.target is the clicked element object
      this.AddAnalitics(event, "click");
    },
    getDBSearchedSponsors: function () {
      self.IsSearchMode = true;
      console.log(self.searchtext);
      debugger;

      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var listRef = "";
      listRef = db
        .collection(obj.eventcollectionname) //"OA_UAT_C1591205467009E1591206650065")
        .doc("SponsorList")
        .collection("Sponsors")
        .where("IsPublished", "==", true)
        .orderBy("Name", "asc");

      //var speakerlistLocal = [];
      listRef
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var filteredRows = self.sponsorsData.filter(function (value) {
              return value.id == doc.id;
            });
            if (filteredRows.length == 0) {
              var tbObj = new Object();
              tbObj.id = doc.id;
              tbObj.BoothNo =
                doc.data().BoothNo == undefined ? "" : doc.data().BoothNo;

              tbObj.Email =
                doc.data().Email != undefined ? doc.data().Email : "";

              tbObj.Level =
                doc.data().Level != undefined ? doc.data().Level : "";

              tbObj.Logo =
                doc.data().Logo != undefined
                  ? self.getCDNUrl(doc.data().Logo)
                  : "";

              tbObj.Name = doc.data().Name != undefined ? doc.data().Name : "";

              tbObj.Phone =
                doc.data().Phone == undefined ? "" : doc.data().Phone;

              tbObj.Profile = doc.data().Profile ? doc.data().Profile : "";

              tbObj.SponsorId = doc.data().SponsorId
                ? doc.data().SponsorId
                : "";

              tbObj.Website =
                doc.data().Website == undefined ? "" : doc.data().Website;

              tbObj.Category =
                doc.data().Category != undefined ? doc.data().Category : "";

              if (
                tbObj.BoothNo.toLowerCase().includes(
                  self.searchtext.toLowerCase()
                ) ||
                tbObj.Email.toLowerCase().includes(
                  self.searchtext.toLowerCase()
                ) ||
                tbObj.Level.toLowerCase().includes(
                  self.searchtext.toLowerCase()
                ) ||
                tbObj.Name.toLowerCase().includes(
                  self.searchtext.toLowerCase()
                ) ||
                tbObj.Phone.toLowerCase().includes(
                  self.searchtext.toLowerCase()
                ) ||
                tbObj.Profile.toLowerCase().includes(
                  self.searchtext.toLowerCase()
                )
              ) {
                self.sponsorsData.push(tbObj);
              }
            }
            if (self.sponsorsData.length > 0) {
              self.IsShowNoDataFound = false;
            } else {
              self.IsShowNoDataFound = true;
            }
          });

          // self.sponsorsData.sort(function (a, b) {
          //   if (a.Name < b.Name) {
          //     return -1;
          //   }
          //   if (a.Name > b.Name) {
          //     return 1;
          //   }
          //   return 0;
          // });
        })
        .catch((error) => {
          console.log(error);
          // console.log("Error getting documents: ", error);
        });
    },
    displaySponsors() {
      if (!hasMore) {
        return;
      }
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      console.log("EventColName : " + obj.eventcollectionname);

      this.pageIndex++;
      var listRef = db
        .collection(obj.eventcollectionname) //"OA_UAT_C1591205467009E1591206650065")
        .doc("SponsorList")
        .collection("Sponsors")
        .where("IsPublished", "==", true)
        .orderBy("Category.CategoryPriority", "asc")
        .orderBy("Name", "asc");

      let srchText = self.searchtext.trim().toLowerCase();
      if (srchText == "" && !self.$route.params.aid) {
        if (lastVisible == null) {
          listRef = listRef.limit(this.pageSize);
        } else {
          listRef = listRef.startAfter(lastVisible).limit(this.pageSize);
        }
      }
      listRef
        .get()
        .then((querySnapshot) => {
          hasMore = querySnapshot.docs.length > 0;
          if (hasMore) {
            lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
          }
          querySnapshot.forEach((doc) => {
            var filteredRows = self.sponsorsData.filter(function (value) {
              return value.id == doc.id;
            });

            if (filteredRows.length == 0) {
              var data = doc.data();

              self.sponsorsData.push({
                id: doc.id,
                BoothNo: data.BoothNo,
                Email: data.Email,
                Level: data.Level,
                Logo: self.getCDNUrl(data.Logo),
                Name: data.Name,
                Phone: data.Phone,
                Profile: data.Profile,
                SponsorId: data.SponsorId,
                Website: data.Website,
                Category: data.Category,
              });
            }
          });

          /*Filter portion*/
          $("#dropFilter").append(
            "<li id='select-all-li'><label class='terms_text'>All<input type='checkbox' checked='' name='type' class='theClass' onchange='filterOnchange(this);' value='All'><span class='checkmark'></span></label></li>"
          );

          $.each(self.sponsorsData, function (key1, value1) {
            $("#dropFilter").append(
              "<li id='select-all-li'><label class='terms_text'>" +
                value1.Level +
                "<input type='checkbox' checked='' id='chkfilter' name='type' class='theClass' onchange='filterOnchange(this);' value='" +
                value1.Level +
                "'><span class='checkmark'></span></label></li>"
            );
          });
        })
        .catch((error) => {
          console.log(error);
          // console.log("Error getting documents: ", error);
        });
      //}
    },
    displaySponsors1() {
      self.IsSearchMode = true;

      if (self.searchtext.trim() != "") {
        if (self.EnableSponsorDBsearch) {
          self.getDBSearchedSponsors();
        } else {
          debugger;
          var hostUrl = location.host.toLowerCase();
          var searchUrl = "";

          //----------------------------------------------------------------------------------------
          if (hostUrl.includes("localhost")) {
            searchUrl =
              "https://us-central1-uate2monair.cloudfunctions.net/app/api/searchsponsors/" +
              self.searchtext;
          } else {
            if (hostUrl.includes("uat")) {
              searchUrl =
                "https://us-central1-uate2monair.cloudfunctions.net/app/api/searchsponsors/" +
                self.searchtext;
            } else {
              searchUrl =
                "https://us-central1-uate2monair.cloudfunctions.net/app/api/searchsponsors/" +
                self.searchtext;
            }
          }
          //----------------------------------------------------------------------------------------------------
          self.sponsorsData = [];
          console.log(self.clientID);
          self.eventId = self.getEventID();
          console.log(self.eventId);
          //+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

          let headers = {
            "Content-Type": "application/json",
            apikey: "ws2000rb28082019",
            InstancePrefix: "OA",
            clientID: self.clientID, // "C1591205467009",
            Env: "UAT",
            eventID: self.eventId, //"E1591206650065",
          };

          self.showLoader();
          axios
            .get(searchUrl, false, {
              headers: headers,
            })
            .then((response) => {
              debugger;
              let data = response.data;
              self.sponsorsData = [];
              self.hideLoader();
              //  console.log(data);
              for (var i = 0; i < data.length; i++) {
                // debugger;
                var filteredRows = self.sponsorsData.filter(function (value) {
                  return (
                    value.id ==
                    (data[i]._highlightResult.SponsorId != undefined
                      ? data[i]._highlightResult.SponsorId.value
                      : "")
                  );
                });

                if (filteredRows.length == 0) {
                  var objAttendee = {
                    id:
                      data[i]._highlightResult.SponsorId != undefined
                        ? data[i]._highlightResult.SponsorId.value
                        : "0",
                    BoothNo:
                      data[i]._highlightResult.BoothNo != undefined
                        ? data[i]._highlightResult.BoothNo.value
                        : "",
                    Email:
                      data[i]._highlightResult.Email != undefined
                        ? data[i]._highlightResult.Email.value
                            .replace("<em>", "")
                            .replace("<em>", "")
                            .replace("<em>", "")
                            .replace("<em>", "")

                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")
                            .trim()
                        : "",
                    Level:
                      data[i]._highlightResult.Level != undefined
                        ? data[i]._highlightResult.Level.value
                            .replace("<em>", "")
                            .replace("<em>", "")
                            .replace("<em>", "")
                            .replace("<em>", "")

                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")
                            .trim()
                        : "",
                    Logo:
                      data[i]._highlightResult.Logo != undefined
                        ? data[i]._highlightResult.Logo.value
                            .replace("<em>", "")
                            .replace("<em>", "")
                            .replace("<em>", "")
                            .replace("<em>", "")

                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")
                            .trim()
                        : "",
                    Name:
                      data[i]._highlightResult.Name != undefined
                        ? data[i]._highlightResult.Name.value
                            .replace("<em>", "")
                            .replace("<em>", "")
                            .replace("<em>", "")
                            .replace("<em>", "")

                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")
                            .trim()
                        : "",
                    Phone:
                      data[i]._highlightResult.Phone != undefined
                        ? data[i]._highlightResult.Phone.value
                            .replace("<em>", "")
                            .replace("<em>", "")
                            .replace("<em>", "")
                            .replace("<em>", "")

                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")

                            .trim()
                        : "",
                    Profile:
                      data[i]._highlightResult.Profile != undefined
                        ? data[i]._highlightResult.Profile.value
                            .replace("<em>", "")
                            .replace("<em>", "")

                            .replace("</em>", "")
                            .replace("</em>", "")
                            .trim()
                        : "",
                    SponsorId:
                      data[i]._highlightResult.SponsorId != undefined
                        ? data[i]._highlightResult.SponsorId.value
                        : "",
                    Website:
                      data[i]._highlightResult.Website != undefined
                        ? data[i]._highlightResult.Website.value
                            .replace("<em>", "")
                            .replace("<em>", "")
                            .replace("<em>", "")
                            .replace("<em>", "")
                            .replace("<em>", "")

                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")
                            .replace("</em>", "")

                            .trim()
                        : "",
                  };
                  // debugger;

                  self.sponsorsData.push(objAttendee);
                }
              }

              if (self.sponsorsData.length > 0) {
                self.IsShowNoDataFound = false;
              } else {
                self.IsShowNoDataFound = true;
              }
            })
            .catch((error) => {
              console.log(error);
              self.hideLoader();
              debugger;
              self.IsShowNoDataFound = true;
              return false;
            });
          //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
          lastVisible = null;
          hasMore = true;
        }
      } else {
        if (!hasMore) {
          return;
        }
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        console.log("EventColName : " + obj.eventcollectionname);

        this.pageIndex++;
        var listRef = db
          .collection(obj.eventcollectionname) //"OA_UAT_C1591205467009E1591206650065")
          .doc("SponsorList")
          .collection("Sponsors")
          .where("IsPublished", "==", true)
          .orderBy("Category.CategoryPriority", "asc")
          .orderBy("Name", "asc");

        let srchText = self.searchtext.trim().toLowerCase();
        if (srchText == "" && !self.$route.params.aid) {
          if (lastVisible == null) {
            listRef = listRef.limit(this.pageSize);
          } else {
            listRef = listRef.startAfter(lastVisible).limit(this.pageSize);
          }
        }
        listRef
          .get()
          .then((querySnapshot) => {
            hasMore = querySnapshot.docs.length > 0;
            if (hasMore) {
              lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
              querySnapshot.forEach((doc) => {
                var filteredRows = self.sponsorsData.filter(function (value) {
                  return value.id == doc.id;
                });

                if (filteredRows.length == 0) {
                  var data = doc.data();

                  self.sponsorsData.push({
                    id: doc.id,
                    BoothNo: data.BoothNo,
                    Email: data.Email,
                    Level: data.Level,
                    Logo: self.getCDNUrl(data.Logo),
                    Name: data.Name,
                    Phone: data.Phone,
                    Profile: data.Profile,
                    SponsorId: data.SponsorId,
                    Website: data.Website,
                    Category: data.Category,
                  });
                }
              });

              /*Filter portion*/
              $("#dropFilter").append(
                "<li id='select-all-li'><label class='terms_text'>All<input type='checkbox' checked='' name='type' class='theClass' onchange='filterOnchange(this);' value='All'><span class='checkmark'></span></label></li>"
              );

              $.each(self.sponsorsData, function (key1, value1) {
                $("#dropFilter").append(
                  "<li id='select-all-li'><label class='terms_text'>" +
                    value1.Level +
                    "<input type='checkbox' checked='' id='chkfilter' name='type' class='theClass' onchange='filterOnchange(this);' value='" +
                    value1.Level +
                    "'><span class='checkmark'></span></label></li>"
                );
              });
            }
          })
          .catch((error) => {
            console.log(error);
            // console.log("Error getting documents: ", error);
          });
      }
    },
    searchSponsors: function () {
      $("#divSponsor").html("");
      self.totalRecords = 1;
      self.firstPageCalled = false;
      self.pageIndex = 0;
      hasMore = true;
      lastVisible = null;
      self.sponsorsData = [];

      setTimeout(function () {
        self.displaySponsors();
      }, 1000);
    },
    searchSponsors2: function () {
      if (self.searchtext == "") {
        // $("#dvAttendeeWrapper").html("");
        self.totalRecords = 1;
        self.firstPageCalled = false;
        self.pageIndex = 0;
        hasMore = true;
        lastVisible = null;
        self.sponsorsData = [];

        self.displaySponsors();
      }
    },
    scroll: function () {
      //window.onscroll = () => {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight + 1 >=
        document.documentElement.offsetHeight;
      if (bottomOfWindow) {
        if (self.searchtext.trim() == "") {
          this.displaySponsors();
        }
        //this.AddAnalitics(event, "scroll");
      }
      //};
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },

    hideLoader: function () {
      //if (timerLoader != null) {
      clearTimeout(this.timerLoader);
      // console.log("outside");
      if ($("#divLoading") != null) {
        //console.log("inside");
        $("#divLoading").hide();
      }
      //}
    },
    getEventID() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.eventid;
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          debugger;
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    mob_spolist_search() {
      $("#mob_spon_search").css("display", "flex");
      $(".mob_search_button").css("opacity", "0 ");
    },
  },
};
</script>
